<script setup>
import { computed } from 'vue'
import ProductCard from './ProductCard.vue'

const props = defineProps({
    products: Array,
    batches: Array,
    type: {
        type: [Object, Function],
        required: false
    },
    isBrochureMode: {
        type: [Boolean, String],
        default: false
    },
    showPrices: {
        type: [Boolean, String],
        default: true
    },
    showBotanical: {
        type: [Boolean, String],
        default: false
    },
    showCommonNameSubtitle: {
        type: [Boolean, String],
        default: false
    },
    defaultImage: {
        type: String,
        default: '/images/default.jpg'
    }
})

const items = computed(() => {
    return props.products?.length ? props.products : props.batches ?? []
})

const getComponentType = (item) => {
    if (props.type) {
        return props.type
    }

    if (item.batch) {
        return props.type
    }

    return ProductCard
}
</script>

<template>
    <div class="grid grid--3">
        <component
            v-for="(item, index) in items"
            :is="getComponentType(item)"
            :key="index"
            :product="item.product ?? item"
            :batch="item.batch ?? item"
            :is-brochure-mode="props.isBrochureMode"
            :show-prices="props.showPrices"
            :show-botanical="props.showBotanical"
            :show-common-name-subtitle="props.showCommonNameSubtitle"
            :default-image="props.defaultImage"
            class="grid__item product-card"
        />
    </div>
</template>
